import { useQuery } from '@tanstack/react-query'
import { fetchData } from '../../api/fetchJson'
import { orgPath } from '../../config/orgId'

export type BankAccount = {
  id: string
  account_name: string
  bank_name: string
  account_number: string | null
  ifsc_code: string | null
  is_active: boolean
}

export function useBankAccounts() {
  return useQuery<BankAccount[]>({
    queryKey: ['bank-accounts'],
    queryFn: () => fetchData<BankAccount[]>(orgPath('/bank-accounts')),
    staleTime: 30_000,
  })
}
